import React from "react";
import { Button } from "primereact/button";

export default function footerButton({ onClickOk, onClickCancle, disabled }) {
    return (
        <div style={{ textAlignLast: "end" }}>
            <Button label="ตกลง" icon="pi pi-check" onClick={() => onClickOk()} style={{ marginLeft: 5 }} className="p-button p-button-success" disabled={disabled} />
            <Button label="ยกเลิก" icon="pi pi-times" onClick={() => onClickCancle()} style={{ backgroundColor: "rgb(167 172 175)", color: "#ffffff" }} className="p-button p-button-danger" />
        </div>
    );
}

export const FooterButtonCenter = ({ onClickOk, onClickCancle, disabled }) => {
    return (
        <div style={{ textAlign: "center" }}>
            <Button label="ตกลง" icon="pi pi-check" onClick={() => onClickOk()} style={{ marginLeft: 5 }} className="p-button p-button-success" disabled={disabled} />
            <Button label="ยกเลิก" icon="pi pi-times" onClick={() => onClickCancle()} className="p-button p-button-danger" />
        </div>
    );
};

export const FooterButtonSigle = ({ btnLabel, onClick }) => {
    return (
        <div style={{ textAlign: "center" }}>
            <Button label={btnLabel} icon="pi pi-times" onClick={onClick} style={{ backgroundColor: "#607D8B", color: "#ffffff" }} className="p-button p-button-secondary" />
        </div>
    );
};

export const FooterButtonSuccess = ({ btnLabel, onClick }) => {
    return (
        <div style={{ textAlign: "center" }}>
            <Button label={btnLabel} onClick={onClick} style={{ marginLeft: 5 }} className="p-button p-button-success" />
        </div>
    );
};

export const FooterButtonNoIc = ({ btnLabel, onClick }) => {
    return (
        <div style={{ textAlign: "center" }}>
            <Button label={btnLabel} onClick={onClick} style={{ backgroundColor: "#607D8B", color: "#ffffff" }} className="p-button p-button-secondary" />
        </div>
    );
};

export const FooterButtonSigleCustom = ({ btnLabel, icon, onClick }) => {
    return (
        <div style={{ textAlign: "center" }}>
            <Button label={btnLabel} icon={icon} onClick={onClick} style={{ backgroundColor: "#607D8B", color: "#ffffff" }} className="p-button p-button-secondary" />
        </div>
    );
};

export const FooterButtonCustomLabel = ({ labelCon, lableCan, onClickOk, onClickCancle, disabled }) => {
    return (
        <div style={{ textAlign: "center" }}>
            <Button label={labelCon} icon="pi pi-check" onClick={onClickOk} style={{ marginLeft: 5 }} className="p-button p-button-success" disabled={disabled} />
            <Button label={lableCan} icon="pi pi-times" onClick={onClickCancle} className="p-button p-button-danger" />
        </div>
    );
};
